import Vue from 'vue'
import $x from '../js/$x'
import init from '../js/init'
import publics from '../js/publicCall'
import router from '../router/router.js'
import store from '../store'

import main from '../views/app.vue'
import {
    Button, Swipe, SwipeItem, Cell, CellGroup, Tabbar, TabbarItem, Tabs, Tab,
    Grid, GridItem, Icon, NavBar, Field, Calendar, Collapse, CollapseItem,
    Tag, DatetimePicker, Popup, Checkbox, TreeSelect, Overlay, ActionSheet,
    Skeleton
} from 'vant'

require('../css/index.scss');

// 仅对 npm run build-preview 时，使用客户端mock数据（拦截XMLHttpRequest）


Object.assign($x, publics)
// 通用组件，便于处理
Vue.prototype.$x = Vue.$x = $x;

// 常用组件在这注册。即可实现按需加载，又不必每个页面调用Vue.use。
Vue.use(Button).use(Checkbox)
    .use(Swipe).use(SwipeItem)
    .use(Cell).use(CellGroup)
    .use(Tabbar).use(TabbarItem)
    .use(Tabs).use(Tab)
    .use(Grid).use(GridItem)
    .use(Collapse).use(CollapseItem)
    .use(Calendar).use(DatetimePicker)
    .use(Popup).use(Overlay).use(Skeleton)
    .use(Icon).use(NavBar).use(Field).use(Tag).use(TreeSelect).use(ActionSheet);

init().finally(() =>
    new Vue({
        el: '#app',
        router,
        store,
        render: h => h(main),
    })
)
